const auth2Enum = Object.freeze({
  WRONG_FACEBOOK_TOKEN: 1,
  CHANGE_LOGIN_METHOD_ERROR: 2,
  EMAIL_SIGNUP: 10,
  FACEBOOK_NO_EMAIL: 20,
});

export default auth2Enum;
